module.exports = __webpack_public_path__ + "img/156-Skai Woodec Sheffield Oak Concrete.jpg";